let language = {
    "LBL_HOME":"Home",
    "LBL_CREATE_WORK_PACKS":"Create Applicaton Package",
    "LBL_VIEW_WORK_PACK":"View Applicaton Package",
    "LBL_WORK_PACK_NAME":"Applicaton Package Name",
    "LBL_WORk_PACK_DESCRIPTION":"Description",
    "LBL_STATUS":"Status",
    "LBL_WORK_PACKS_DATE":"Created Date",
    "LBL_RELATED_OPPORTUNITY":"Related Opportunity",
    "LBL_UPLOAD_DOCS":"Upload Document",
    "LBL_OPPORTUNITY_TITLE":"Select Opportunity",
    "LBL_WORKPACKAGE_NAME":"Applicaton Package Name",
}

export default language;